import { voidFunction } from '@avantia/client-and-server-utilities';
import { HpQuestionSet } from '@avantia/questionset-model';
import { setRumGlobalContext } from '@avantia/third-party-monitoring/configureDataDogRum';
import { fetchResolver } from '../engineClient/actions/fetchResolver';
import { getQuestionSet as getEngineQuestionSet } from '../engineClient/actions/getQuestionSetAction';
import { HpGetQuestionSetActionProps, HpQuestionSetPayload } from '../engineClient/actions/getQuestionSetActionTypes';
import { setAnswersIdCookie, setProductIdCookie } from '../engineClient/tools/cookieUtilities';
import { HpDispatchFunction } from '../engineClient/types';
import { getAgentCookie } from '../handlers/handlerUtilities';
import { HpClaimsDispatchFunction } from '../types/actionTypes';

interface MaybeStatusError {
  statusCode?: number;
}

function isUnauthorisedError(reason: unknown): boolean {
  const error = reason as MaybeStatusError;
  if (!error) {
    return false;
  }

  return error.statusCode === 401;
}

export type HpGetQuestionSetActionResponse = (dispatch: HpDispatchFunction<HpQuestionSetPayload>) => Promise<void>;
export interface HpClaimsGetQuestionSetActionProps extends HpGetQuestionSetActionProps {
  isNewJourney?: boolean;
  answersId?: string;
}

export function getQuestionSetAction(
  props: HpClaimsGetQuestionSetActionProps
): (dispatch: HpClaimsDispatchFunction<HpQuestionSet>) => Promise<void> {
  const { isNewJourney = true, queryParams, answersId } = props;
  return (dispatch: HpClaimsDispatchFunction<HpQuestionSet>): Promise<void> => {
    const prm = getEngineQuestionSet({ ...props, queryParams: { ...queryParams, isNewJourney, answersId } });
    prm.catch(voidFunction);
    return fetchResolver({
      options: prm.then((questionSet) => {
        const { answersId, productId } = questionSet;
        if (answersId) {
          setAnswersIdCookie(answersId);
          setProductIdCookie(productId);
          setRumGlobalContext('answersId', answersId);
          setRumGlobalContext('agentId', getAgentCookie() || 'customer');
        }

        return questionSet;
      }),
      dispatch,
      loadingPageType: 'overlay',
      successAction: (questionSet) => {
        dispatch({ type: 'QUESTIONSET_RETRIEVED', payload: { questionSet, keepAnswers: !isNewJourney } as any });
        dispatch({ type: 'POLICIES_RETRIEVED', payload: questionSet });
      },
      failedAction: (reason) => {
        if (isUnauthorisedError(reason)) {
          dispatch({ type: 'CLAIMS_SESSION_EXPIRED' });
          return { dispatchFetchError: false, rejectPromise: false };
        }

        return undefined;
      }
    });
  };
}

export function getQuestionSet({
  productId,
  metadata,
  needs,
  setCustomAnswers,
  queryParams
}: HpGetQuestionSetActionProps): Promise<HpQuestionSet> {
  return getEngineQuestionSet({
    productId,
    metadata,
    needs,
    setCustomAnswers,
    queryParams: { ...queryParams }
  });
}
